import { Component, Input, OnInit, SecurityContext } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HelpService } from '../../../../shared/service/help.service';
import { HELP_MANAGE_STUDIES_FIELDMAP_GEOREFERENCE } from '../../../../app.constants';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { UrlService } from '../../../../shared/service/url.service';

@Component({
    selector: 'jhi-create-field-map-modal',
    templateUrl: './geo-reference-modal.component.html'
})
export class GeoReferenceModalComponent implements OnInit {

    @Input() studyId: number;
    @Input() instanceId: number;
    @Input() programUUID: string;
    @Input() cropName: string;
    @Input() isViewGeoJson: boolean;
    helpLink: string;
    url: string;

    safeUrl: SafeResourceUrl;

    constructor(private activeModal: NgbActiveModal,
                private helpService: HelpService,
                private sanitizer: DomSanitizer,
                private urlService: UrlService) {
    }

    ngOnInit(): void {
        // Get helplink url
        if (!this.helpLink || !this.helpLink.length) {
            this.helpService.getHelpLink(HELP_MANAGE_STUDIES_FIELDMAP_GEOREFERENCE).toPromise().then((response) => {
                this.helpLink = response.body;
            }).catch((error) => {});
        }

        this.url = '/ibpworkbench/controller/brapi-fieldmap?'
            + 'instanceId=' + this.instanceId
            + '&studyId=' + this.studyId
            + '&programUUID=' + this.programUUID
            + '&cropName=' + this.cropName;
        if (this.isViewGeoJson) {
            this.url += '&hasLayout=true';
        }

        this.safeUrl = this.getSafeUrl();
    }

    getSafeUrl(): SafeResourceUrl {
        const safeUrl = this.urlService.buildSafeUrl(this.url);
        return safeUrl !== null
            ? this.sanitizer.bypassSecurityTrustResourceUrl(safeUrl)
            : this.sanitizer.bypassSecurityTrustResourceUrl('about:blank');
    }

    cancel() {
        this.activeModal.dismiss();
    }
}
